"use strict";

PF.Map = PF.Map || {};

PF.Map.Polygon = class Polygon extends PF.Widget {
    static get options() {
        return {
            models: undefined,
            modelsConfig: { filterConfig: { rule: '' } },
            polygonProperties: {
                hintContent: "Многоугольник"
            },
            polygonOptions: {
                fillColor: '#00FF0088',
                strokeWidth: 5
            }
        };
    }


    init() {
        if (this.models === undefined) {
            this.modelsConfig.list = this;
            this.models = new PF.Models(this.modelsConfig);
        } else {
            this.models.list = this;
            PF.Options.assignOptions(this.models, this.modelsConfig);
        }

        this.models.on('addOne', this.addOneSlot.bind(this));
        this.models.on('remove', this.removeSlot.bind(this));

        this.mapPolygon = new ymaps.Polygon([], this.polygonProperties, this.polygonOptions);
        this.map.geoObjects.add(this.mapPolygon);

        this.models.on('changed', () => {
            this.recreate();
        }, true);

    }

    recreate() {
        let cords = [];
        for (let i = 0; i < this.models.length; i++) {
            if (this.models[i] instanceof Array) {
                cords.push(this.models[i]);
            } else {
                cords.push([this.models[i].lat, this.models[i].lng]);
            }
        }
        this.mapPolygon.geometry.setCoordinates([cords]);
    }

    addOneSlot(model) {
        this.recreate();
    }

    removeSlot(removed) {
        this.recreate();
    }

    update(limit = this.length) {
        this.models.update(limit);
    }

    destroy() {
        this.map.geoObjects.remove(this.mapPolygon);
        super.destroy();

    }
};